import React, { useState, useRef, useEffect } from 'react';
import { E as EmbeddedSandbox } from '../EmbeddedSandbox-f9b87581.js';
import 'whatwg-mimetype';
import 'zen-observable-ts';
import 'eventemitter3';
import 'graphql-ws';
import 'subscriptions-transport-ws';

function ApolloSandboxReact(props) {
  const [wrapperElement, setWrapperElement] = useState();
  const currentEmbedRef = useRef(); // we need to default to empty objects for the objects type props
  // that show up in the useDeepCompareEffect below, because useDeepCompareEffect
  // will throw if all of its deps are primitives (undefined instead of objects)

  const {
    handleRequest,
    includeCookies,
    className
  } = props;
  useEffect(() => {
    var _a;

    if (!wrapperElement) return;
    (_a = currentEmbedRef.current) === null || _a === void 0 ? void 0 : _a.dispose();
    currentEmbedRef.current = new EmbeddedSandbox(Object.assign(Object.assign({}, props), {
      target: wrapperElement
    }));
    return () => {
      var _a;

      return (_a = currentEmbedRef.current) === null || _a === void 0 ? void 0 : _a.dispose();
    };
  }, [handleRequest, includeCookies, className, wrapperElement]);
  return React.createElement("div", {
    className: className,
    ref: element => {
      setWrapperElement(element);
    }
  });
}

export { ApolloSandboxReact as ApolloSandbox };
